import { useRef } from 'react'
import { Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconAlertTriangle } from '@tabler/icons-react'

interface CancelSubscriptionModalProps {
  modalRef: React.RefObject<HTMLDialogElement>
  onConfirm: () => void
  isLoading?: boolean
  periodEnd?: string | null
}

export function useCancelSubscriptionModal() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()
  return { modalRef, show, close }
}

export function CancelSubscriptionModal({
  modalRef,
  onConfirm,
  isLoading,
  periodEnd,
}: CancelSubscriptionModalProps) {
  const formattedDate = periodEnd
    ? new Date(periodEnd).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : null

  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="bg-error bg-opacity-20 text-error rounded-full p-4">
            <IconAlertTriangle size={36} />
          </div>
          <span className="text-xl font-bold text-center">Abo kündigen</span>
        </div>
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-4 items-center">
          <p className="text-center text-base-content opacity-80">
            Möchtest du dein Abo wirklich kündigen?
            {formattedDate && (
              <> Dein Zugang bleibt bis zum <strong>{formattedDate}</strong> bestehen.</>
            )}
          </p>
          <div className="flex flex-row gap-3 justify-center">
            <form method="dialog">
              <Button color="ghost" disabled={isLoading}>Abbrechen</Button>
            </form>
            <Button color="error" onClick={onConfirm} loading={isLoading} disabled={isLoading}>
              Abo kündigen
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
